.svs-sorting {
  position: relative;

  &-cta {
    align-items: center;
    background-color: $svs-white;
    border: 1px solid $svs-se-dark-grey;
    border-radius: 4px;
    color: $svs-anthracite-grey;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    line-height: 24px;
    justify-content: space-between;
    padding: 4px 8px;

    @media (max-width: 980px) {
      // To be inline with qds buttons
      font-size: 14px;
      line-height: 23px;
      padding: 8px;
    }

    @media (max-width: $uiaas-tablet) {
      border: 1px solid $svs-super-light-grey;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      font-size: 16px;
      line-height: 24px;
      width: 100%;
    }

    &__icon {
      margin-left: 10px;

      &--inversed {
        transform: rotate(180deg);
      }
    }
  }

  &-dropdown {
    min-width: 100%;
    z-index: 100; // Ensure dropdown is above content
  }
}
